import { useNftx } from '@nftx/react';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';

const useInventoryPools = () => {
  const {
    network,
    core: { fetchInventoryPools },
  } = useNftx();
  return useQuery([QueryKey.INVENTORY_POOLS, network], () => {
    return fetchInventoryPools({ network });
  });
};

export default useInventoryPools;
